import { Text } from '@backend/lib-design-system';
import { ArrowBackFilledIcon } from '@backend/lib-design-system/icons';
import { useRouter } from 'next/router';
import { styled } from 'styled-components';

import { getJobsBusinessUnitUrl } from '~/config';
import { useBusinessUnitContext } from '~/contexts/BusinessUnitContext/BusinessUnitContext';
import { useTrackingContext } from '~/contexts/TrackingContext';
import { useTranslation } from '~/hooks';

const StyledBackBtn = styled(Text)`
  display: flex;
  gap: 5px;
  align-items: center;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.info?.normal};
`;

export const BackBtn = () => {
  const t = useTranslation();
  const { push, back } = useRouter();
  const { referer } = useTrackingContext();
  const { businessUnit } = useBusinessUnitContext();

  const onClick = async () => {
    if (referer) {
      back();
    } else {
      await push(getJobsBusinessUnitUrl(businessUnit));
    }
  };

  return (
    <StyledBackBtn variant="body" onClick={onClick}>
      <ArrowBackFilledIcon />
      {t('missions.back')}
    </StyledBackBtn>
  );
};
